import { Component, View, ViewModel } from "binder";
import { PopupViewModel, Position } from "../popup/popup-viewModel";
import { getAsBoolean } from "../utilities";
import  { TogglePopupView } from "./togglePopup-view"

export class TogglePopupViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.isshowing = false;
        this._windowClick = this.windowClick.bind(this);
        this._containerClick = this.containerClick.bind(this);
        this._popupClick = this.popupClick.bind(this);
        this.closeoncontainerclick = true;
        this.closeoncontrolclick=true;
        this.shallIgnoreWindowClick = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new TogglePopupView();
    }
    public getTypeId(): string {
        return "VM-207FBD81-13A7-4B5C-B76C-76C588DC99ED"
    }
    public set closeoncontainerclick(v: boolean) { this._closeoncontainerclick =getAsBoolean(v); } public get closeoncontainerclick(): boolean { return this._closeoncontainerclick;} private _closeoncontainerclick: boolean;
    public set closeoncontrolclick(v: boolean) { this._closeoncontrolclick = getAsBoolean(v); } public get closeoncontrolclick(): boolean { return this._closeoncontrolclick;} private _closeoncontrolclick: boolean;
    

    public set thisElement(v: HTMLElement) { this._thisElement = v; } public get thisElement(): HTMLElement { return this._thisElement;} private _thisElement: HTMLElement;
    public set popupContainer(v: HTMLElement) { this._popupContainer = v; } public get popupContainer(): HTMLElement { return this._popupContainer;} private _popupContainer: HTMLElement;

    public set popup(v: PopupViewModel) { this._popup = v; } public get popup(): PopupViewModel { return this._popup;} private _popup: PopupViewModel;
    public set preferedposition(v: number) { 
        if(typeof v!=='number')
            v=parseInt(v);
        this._preferedPosition = v;
    } public get preferedposition(): number { return this._preferedPosition;} private _preferedPosition: number;
    public set isshowing(v: boolean) { 
        this._isshowing = v; 
        if(this.popup==null)
            return;
        if(this.isshowing){
            this.addListenners();
            this.popup.origin = this.getpopupPosition();
            this.popup.isShowing = true;
        }else{
            this.removeListenners();
            this.popup.isShowing = false;
        }
    } public get isshowing(): boolean { return this._isshowing;} private _isshowing: boolean;
    
    public set preferredwidth(v: string) { this._preferredwidth = v; } public get preferredwidth(): string { return this._preferredwidth;} private _preferredwidth: string;
    

    toggle() {
        this.isshowing = !this.isshowing;
    }
    private shallIgnoreWindowClick:boolean;
    ignoreWindowClick(){
        this.shallIgnoreWindowClick = true;
    }
    private windowClick(e){
        if(this.shallIgnoreWindowClick){
            this.shallIgnoreWindowClick = false;
            return;
        }
        this.isshowing = false;
    }
    private containerClick(e:MouseEvent){
        if(this.closeoncontainerclick==true || this.isshowing==false)
            this.toggle();
        e.stopPropagation();
    }
    popupClick(e){
        e.stopPropagation();
    }
    private _windowClick;
    private _containerClick;
    private _popupClick;
    private addListenners(){
        window.addEventListener('click',this._windowClick);
        this.thisElement.addEventListener('click',this._containerClick);
        this.popupContainer.addEventListener('click',this._popupClick);
    }
    private removeListenners(){
        window.removeEventListener('click',this._windowClick);
        this.thisElement.removeEventListener('click',this._containerClick);
        this.popupContainer.addEventListener('click',this._popupClick);
    
    }
    
    getpopupPosition():Position{
        let r = this.thisElement.getBoundingClientRect();
        switch(this.preferedposition){
            case 1:
                return new Position(r.x,r.y,0,0);
            case 2:
                return new Position(r.x + r.width,r.y,0,0);
            case 3:
                return new Position(r.x + r.width,r.y + r.height,0,0);
            case 4:
                return new Position(r.x,r.y + r.height,0,0);
            default:
                return new Position(r.x,r.y,r.width,r.height);
        }
    }
}
